__turbopack_context__.v({
  "container": "ServicesFeaturesSection-module-scss-module__-Dj1OW__container",
  "root": "ServicesFeaturesSection-module-scss-module__-Dj1OW__root",
  "wrapper": "ServicesFeaturesSection-module-scss-module__-Dj1OW__wrapper",
});
